import { TbListCheck } from 'react-icons/tb';
import type { IconProps } from './IconBase';
import { IconBase } from './IconBase';

export const TaskListIcon = (props: IconProps) => {
  return <IconBase icon={TbListCheck} {...props} />;
};
